<tcc-simplePanel size="full" [options]="{ respondsToMainMenu: true }">
    <div panel-header>Master Calculations</div>
    <div panel-body class="d-flex flex-column h-100">
      <div class="pb-3">
        <p>The following will perform calculations on all organizations.  It will not submit workflows or import anything.</p>
        <button *ngFor="let c of configurations" class="btn btn-link" (click)="currentConfig = c">
          <i [ngClass]="c.icon"></i> {{c.name}}
        </button>
      </div>
      <div class="pb-3" *ngIf="currentConfig">
        <div class="d-flex flex-row">
          <h3 class="h4">{{currentConfig.name}}</h3>
          <button class="btn btn-link" [disabled]="state === 'running' || orgSelectedCount === 0"  (click)="deselectAllOrgs()">
            <i class="fa fa-minus-circle"></i> Deselect All
          </button>
          <button class="btn btn-link" [disabled]="state === 'running' || orgSelectedCount === currentConfig?.destOrgs!.length"
              (click)="selectAllOrgs()">
            <i class="fa fa-check-circle"></i> Select All
          </button>
          <button class="btn btn-link" [disabled]="state === 'running' || orgSelectedCount === 0"  (click)="startTransforms()">
            <i class="fas fa-bolt"></i> Run Process
          </button>
        </div>
        <div style="display:inline-block; vertical-align:baseline; width:90px;" *ngFor="let o of currentConfig?.destOrgs">
          <label [title]="orgIndex?.get(o.orgCode)?.name">
            <input type="checkbox" [tccFaCheckStyle]="checkStyle" class="fa-stack-sm" [(ngModel)]="o.isSelected" [disabled]="state === 'running'" />
            {{o.orgCode}}
          </label>
        </div>
        <div *ngIf="orgSelectedCount !== currentConfig?.destOrgs!.length" class="pt-2">
          Calculation Mode: 
          <button class="btn btn-link p-0" [disabled]="state === 'running'" (click)="toggleCalculateAllProperties()">
            <i class="fa" [ngClass]="calculateAllProperties ? 'fa-toggle-on' : 'fa-toggle-off'"></i>
            {{ calculateAllProperties ? 'Calculate all properties' : 'Calculate selected properties and dependencies' }}
          </button>
        </div>
      </div>
      <div>
          <h3 class="h4">Process Log</h3>
      </div>
      <div style="flex-grow:1; overflow:auto">
          <app-simpleLog [log]="log" tableClass="table table-sm table-striped table-bordered"></app-simpleLog>
      </div>
    </div>
  </tcc-simplePanel>
